export const CONTRACT_TEMPLATES = {
  service_agreement: {
    name: 'Service Agreement',
    description: 'Standard consulting services agreement',
    template: (data) => `SERVICE AGREEMENT

This Service Agreement ("Agreement") is entered into as of ${data.date} ("Effective Date") by and between:

SERVICE PROVIDER:
${data.companyName}
${data.companyAddress}
Email: ${data.companyEmail}
ABN: ${data.companyAbn || '14187234379'}

CLIENT:
${data.clientName}
${data.clientAddress}
Email: ${data.clientEmail}

1. SERVICES
Service Provider agrees to provide the following services to Client:
${data.services || 'Supply chain intelligence and IoT analytics consulting services as agreed upon by both parties.'}

2. TERM
This Agreement shall commence on ${data.startDate || data.date} and continue until ${data.endDate || 'completion of services'}, unless terminated earlier in accordance with this Agreement.

3. COMPENSATION
Client agrees to pay Service Provider the fees as outlined in any associated Statement of Work or as otherwise agreed in writing.

4. CONFIDENTIALITY
Both parties agree to maintain confidentiality of proprietary information exchanged during the term of this Agreement.

5. LIMITATION OF LIABILITY
Service Provider's liability shall be limited to the amount paid by Client under this Agreement.

6. GOVERNING LAW
This Agreement shall be governed by the laws of ${data.jurisdiction || 'Australia'}.

IN WITNESS WHEREOF, the parties have executed this Agreement as of the Effective Date.

_____________________________
${data.companyName}
By: ${data.companySigner || 'Authorized Representative'}
Date: ${data.date}

_____________________________
${data.clientName}
By: ${data.clientSigner || 'Authorized Representative'}
Date: ${data.date}`,
  },

  nda: {
    name: 'Non-Disclosure Agreement (NDA)',
    description: 'Protect confidential business information',
    template: (data) => `NON-DISCLOSURE AGREEMENT

This Non-Disclosure Agreement ("Agreement") is entered into as of ${data.date} ("Effective Date") by and between:

DISCLOSING PARTY:
${data.companyName}
${data.companyAddress}
Email: ${data.companyEmail}

RECEIVING PARTY:
${data.clientName}
${data.clientAddress}
Email: ${data.clientEmail}

1. PURPOSE
The parties wish to explore a potential business relationship ("Purpose") and in connection with this Purpose, the Disclosing Party may disclose certain confidential information to the Receiving Party.

2. DEFINITION OF CONFIDENTIAL INFORMATION
"Confidential Information" means any and all non-public, proprietary, or confidential information disclosed by the Disclosing Party, whether orally or in writing.

3. OBLIGATIONS OF RECEIVING PARTY
The Receiving Party agrees to hold all Confidential Information in strict confidence and not disclose it to third parties.

4. TERM
This Agreement shall remain in effect for ${data.ndaTerm || 'three (3) years'} from the Effective Date.

5. GOVERNING LAW
This Agreement shall be governed by the laws of ${data.jurisdiction || 'Australia'}.

IN WITNESS WHEREOF, the parties have executed this Agreement as of the Effective Date.

_____________________________
${data.companyName}
By: ${data.companySigner || 'Authorized Representative'}
Date: ${data.date}

_____________________________
${data.clientName}
By: ${data.clientSigner || 'Authorized Representative'}
Date: ${data.date}`,
  },

  proposal: {
    name: 'Project Proposal',
    description: 'Formal project proposal with terms',
    template: (data) => `PROJECT PROPOSAL

Date: ${data.date}
Proposal #: PROP-${Date.now().toString().slice(-6)}

PREPARED FOR:
${data.clientName}
${data.clientAddress}
Email: ${data.clientEmail}

PREPARED BY:
${data.companyName}
${data.companyAddress}
Email: ${data.companyEmail}

PROJECT OVERVIEW:
${data.projectOverview || 'The following proposal outlines the scope, timeline, and investment for the project discussed.'}

SCOPE OF WORK:
${data.scopeOfWork || 'Consulting, implementation, and support as agreed.'}

INVESTMENT:
Total Project Value: ${data.projectValue || 'As quoted separately'}
Payment Terms: ${data.paymentTerms || '50% upon commencement, 50% upon completion'}

ACCEPTANCE:
By signing below, the Client agrees to the terms outlined in this proposal.

_____________________________
${data.clientName}
Authorized Signature
Date: _______

_____________________________
${data.companyName}
${data.companySigner || 'Authorized Representative'}
Date: ${data.date}`,
  },
};
